import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import { AxiosError } from "axios"

const getData = async (event_slug?: string) => {
  const response = await axios.get(`/events/${event_slug}/registration/`)
  return response.data
}

export default function useEventRequestsValues(event_slug?: string) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["eventRequests", event_slug],
    queryFn: () => getData(event_slug),
    enabled: !!event_slug,
    retry: (failureCount, error) => {
      if (
        error instanceof AxiosError &&
        (error.response?.status === 403 || error.response?.status === 404)
      ) {
        return false
      }
      return failureCount < 5
    }
  });

  return { data, isLoading, error }
}